import { Dispatch } from "react";
import {
  DisplayAccountPickerState,
  IdentifyUserAction,
} from "../../../hooks/useIdentifyUserFlow";
import { FlexRow } from "../../Common/__styles__/Layout";
import { AccountLogoOrFallbackIcon } from "../../Common/AccountLogo";
import { Section, Sections } from "../../Common/Layout";
import { Title } from "../../Common/Typography";
import { SelectionCard } from "../../Inputs/SelectionCard";
import NavigationCard from "../CommonLoginComponents/NavigationCard";
import { ErrorMessage } from "../ErrorMessage";

export const AccountPicker = ({
  state,
  dispatch,
  onSubmit,
}: {
  state: DisplayAccountPickerState;
  dispatch: Dispatch<IdentifyUserAction>;
  onSubmit: ({
    email,
    userAccount,
  }: {
    email: string;
    userAccount: DisplayAccountPickerState["accounts"][number];
  }) => void;
}) => {
  const { accounts, email, error } = state;

  const onSelectOption = ({ subdomain }: { subdomain: string }) => {
    const userAccount = accounts.find(
      acc => acc.account.subdomain === subdomain,
    );
    if (userAccount) {
      onSubmit({ email, userAccount });
    }
  };

  return (
    <Sections>
      {error && <ErrorMessage error={error} />}
      <Section>
        <Title type="semiBold" size="large">
          Sign in to your account
        </Title>
        <NavigationCard
          onClick={() => {
            dispatch({ type: "goBack" });
          }}
        >
          <SelectionCard.CommonContent iconName="chevron-left" title={email} />
        </NavigationCard>
        <SelectionCard.Group
          handleSelection={(subdomain: string) => onSelectOption({ subdomain })}
          direction="vertical"
          spacing="compact"
        >
          {accounts.map(({ account }) => (
            <SelectionCard.Item
              key={account.id}
              value={account.subdomain}
              borderStyle="ghost"
              size="compact"
            >
              <FlexRow gap="s">
                <AccountLogoOrFallbackIcon account={account} />
                <SelectionCard.CommonContent title={account.name} />
              </FlexRow>
            </SelectionCard.Item>
          ))}
        </SelectionCard.Group>
      </Section>
    </Sections>
  );
};
